import { memo, type SVGProps } from 'react';

export const IconAllChats = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden {...props}>
    <path
      d="M3.73307 13.2796L4.74905 12.4668L4.75652 12.4611C4.96833 12.2916 5.07521 12.2061 5.19445 12.1452C5.30144 12.0905 5.41552 12.0507 5.5332 12.0266C5.66585 11.9993 5.80402 11.9993 6.08138 11.9993H11.8687C12.614 11.9993 12.9871 11.9993 13.272 11.8542C13.5229 11.7263 13.727 11.5222 13.8548 11.2713C14 10.9863 14 10.6137 14 9.8684V4.79729C14 4.05201 14 3.67882 13.8548 3.39388C13.727 3.143 13.5225 2.93917 13.2716 2.81134C12.9864 2.66602 12.6135 2.66602 11.8668 2.66602H4.13346C3.38673 2.66602 3.01308 2.66602 2.72786 2.81134C2.47698 2.93917 2.27316 3.143 2.14532 3.39388C2 3.6791 2 4.05274 2 4.79948V12.4468C2 13.1573 2 13.5124 2.14564 13.6949C2.2723 13.8536 2.46429 13.9459 2.66732 13.9457C2.90077 13.9454 3.17829 13.7234 3.73307 13.2796Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
IconAllChats.displayName = 'IconAllChats';

export const IconUser = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <path
      d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M12 11a4 4 0 100-8 4 4 0 000 8z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
));
IconUser.displayName = 'IconUser';

export const IconPersonal = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden {...props}>
    <path
      d="M12 12.666C12 11.1933 10.2091 9.99935 8 9.99935C5.79086 9.99935 4 11.1933 4 12.666M8 7.99935C6.52724 7.99935 5.33333 6.80544 5.33333 5.33268C5.33333 3.85992 6.52724 2.66602 8 2.66602C9.47276 2.66602 10.6667 3.85992 10.6667 5.33268C10.6667 6.80544 9.47276 7.99935 8 7.99935Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
IconPersonal.displayName = 'IconPersonal';

export const IconGroup = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden {...props}>
    <path
      d="M11.3333 13.334C11.3333 12.2294 9.84095 11.334 8 11.334C6.15905 11.334 4.66667 12.2294 4.66667 13.334M14 11.3342C14 10.5141 13.1773 9.80927 12 9.50065M2 11.3342C2 10.5141 2.82273 9.80927 4 9.50065M12 6.82472C12.4092 6.45851 12.6667 5.92632 12.6667 5.33398C12.6667 4.22941 11.7712 3.33398 10.6667 3.33398C10.1544 3.33398 9.68717 3.52655 9.33333 3.84325M4 6.82472C3.59083 6.45851 3.33333 5.92632 3.33333 5.33398C3.33333 4.22941 4.22876 3.33398 5.33333 3.33398C5.84557 3.33398 6.31283 3.52655 6.66667 3.84325M8 9.33398C6.89543 9.33398 6 8.43855 6 7.33398C6 6.22941 6.89543 5.33398 8 5.33398C9.10457 5.33398 10 6.22941 10 7.33398C10 8.43855 9.10457 9.33398 8 9.33398Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
IconGroup.displayName = 'IconGroup';

export const IconUsers = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <path
      d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 10-4-4 4 4 0 004 4zm6-1a3 3 0 10-3-3 3 3 0 003 3zm4 7v-1a4 4 0 00-3-3.87"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
));
IconUsers.displayName = 'IconUsers';

export const IconPlus = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
));
IconPlus.displayName = 'IconPlus';

export const IconPaperclip = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <path
      d="M4.53564 11.4652L11.4299 4.57089C13.4802 2.52064 16.8044 2.52064 18.8546 4.57089C20.9049 6.62114 20.9046 9.94544 18.8544 11.9957L10.8994 19.9506C9.53258 21.3175 7.31688 21.3173 5.95004 19.9505C4.58321 18.5836 4.58287 16.3678 5.94971 15.0009L13.9047 7.04599C14.5881 6.36257 15.6967 6.36257 16.3801 7.04599C17.0635 7.72941 17.0631 8.83718 16.3796 9.5206L9.48535 16.4149"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
IconPaperclip.displayName = 'IconPaperclip';

export const IconSend = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <path
      d="M16.0207 19.1823L20.1113 5.8877L20.1119 5.88631C20.3999 4.95029 20.544 4.48185 20.4279 4.16553C20.3267 3.88986 20.1094 3.67275 19.8337 3.57155C19.5173 3.45537 19.0486 3.5994 18.1116 3.8877L4.81704 7.97834C3.62523 8.34505 3.02928 8.52876 2.83169 8.845C2.66033 9.11925 2.63207 9.45912 2.75601 9.75781C2.89892 10.1022 3.45662 10.3813 4.57192 10.939L9.76577 13.5359C9.93486 13.6204 10.0215 13.6637 10.0965 13.7215C10.1645 13.774 10.225 13.8353 10.2775 13.9033C10.3366 13.98 10.3809 14.0681 10.4694 14.2451L13.0603 19.427C13.618 20.5423 13.8975 21.1004 14.2419 21.2433C14.5406 21.3673 14.8802 21.3386 15.1544 21.1673C15.4706 20.9697 15.6541 20.3737 16.0207 19.1823Z"
      fill="#FFFFFF"
    />
    <path
      d="M10.3078 13.6914L15.1539 8.84522M20.1113 5.8877L16.0207 19.1823C15.6541 20.3737 15.4706 20.9697 15.1544 21.1673C14.8802 21.3386 14.5406 21.3673 14.2419 21.2433C13.8975 21.1004 13.618 20.5423 13.0603 19.427L10.4694 14.2451C10.3809 14.0681 10.3366 13.98 10.2775 13.9033C10.225 13.8353 10.1645 13.774 10.0965 13.7215C10.0215 13.6637 9.93486 13.6204 9.76577 13.5359L4.57192 10.939C3.45662 10.3813 2.89892 10.1022 2.75601 9.75781C2.63207 9.45912 2.66033 9.11925 2.83169 8.845C3.02928 8.52876 3.62523 8.34505 4.81704 7.97834L18.1116 3.8877C19.0486 3.5994 19.5173 3.45537 19.8337 3.57155C20.1094 3.67275 20.3267 3.88986 20.4279 4.16553C20.544 4.48185 20.3999 4.95029 20.1119 5.88631L20.1113 5.8877Z"
      stroke="#1E1E1E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
IconSend.displayName = 'IconSend';

export const IconFile = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <path
      d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path d="M14 2v6h6" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
  </svg>
));
IconFile.displayName = 'IconFile';

export const IconPlay = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor" aria-hidden {...props}>
    <path d="M8 5v14l11-7L8 5z" />
  </svg>
));
IconPlay.displayName = 'IconPlay';

export const IconKebab = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden {...props}>
    <circle cx="12" cy="5" r="2" />
    <circle cx="12" cy="12" r="2" />
    <circle cx="12" cy="19" r="2" />
  </svg>
));
IconKebab.displayName = 'IconKebab';

export const IconSearch = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <path
      d="M21 21L16.65 16.65M10.5 18C6.35786 18 3 14.6421 3 10.5C3 6.35786 6.35786 3 10.5 3C14.6421 3 18 6.35786 18 10.5C18 14.6421 14.6421 18 10.5 18Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
IconSearch.displayName = 'IconSearch';

export const IconArrowLeft = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <path
      d="M15 6L9 12L15 18"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
IconArrowLeft.displayName = 'IconArrowLeft';

export const IconInfoCircle = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.75" />
    <circle cx="12" cy="8" r="1.35" fill="currentColor" />
    <path d="M12 10.75V17" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
  </svg>
));
IconInfoCircle.displayName = 'IconInfoCircle';

export const IconImage = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <rect
      x="3.75"
      y="5.25"
      width="16.5"
      height="13.5"
      rx="2.25"
      stroke="currentColor"
      strokeWidth="1.8"
    />
    <circle cx="9" cy="10" r="1.5" fill="currentColor" />
    <path
      d="M5.5 16L10 11.5L13 14.5L15.5 12L18.5 16"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
IconImage.displayName = 'IconImage';

export const IconVideo = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <rect
      x="3.75"
      y="6.25"
      width="12.5"
      height="11.5"
      rx="2.25"
      stroke="currentColor"
      strokeWidth="1.8"
    />
    <path
      d="M16.25 10L20 7.75V16.25L16.25 14"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
IconVideo.displayName = 'IconVideo';

export const IconClock = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <circle cx="12" cy="12" r="8.25" stroke="currentColor" strokeWidth="1.8" />
    <path
      d="M12 7.5V12l3 2"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
IconClock.displayName = 'IconClock';

export const IconMessageRead = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 31 16" fill="none" aria-hidden {...props}>
    <path
      d="M11.6668 7.99967L14.9667 11.2995L22.0383 4.22852M8.3667 8.0332L11.6665 11.333M18.7375 4.26204L15.202 7.79758"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
IconMessageRead.displayName = 'IconMessageRead';

export const IconMessageSent = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 31 16" fill="none" aria-hidden {...props}>
    <path
      d="M10.334 8.66602L13.0007 11.3327L19.6673 4.66602"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
IconMessageSent.displayName = 'IconMessageSent';

export const IconSettings = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <path
      d="M20.3499 8.92293L19.9837 8.7192C19.9269 8.68756 19.8989 8.67169 19.8714 8.65524C19.5983 8.49165 19.3682 8.26564 19.2002 7.99523C19.1833 7.96802 19.1674 7.93949 19.1348 7.8831C19.1023 7.82677 19.0858 7.79823 19.0706 7.76998C18.92 7.48866 18.8385 7.17515 18.8336 6.85606C18.8331 6.82398 18.8332 6.79121 18.8343 6.72604L18.8415 6.30078C18.8529 5.62025 18.8587 5.27894 18.763 4.97262C18.6781 4.70053 18.536 4.44993 18.3462 4.23725C18.1317 3.99685 17.8347 3.82534 17.2402 3.48276L16.7464 3.1982C16.1536 2.85658 15.8571 2.68571 15.5423 2.62057C15.2639 2.56294 14.9765 2.56561 14.6991 2.62789C14.3859 2.69819 14.0931 2.87351 13.5079 3.22396L13.5045 3.22555L13.1507 3.43741C13.0948 3.47091 13.0665 3.48779 13.0384 3.50338C12.7601 3.6581 12.4495 3.74365 12.1312 3.75387C12.0992 3.7549 12.0665 3.7549 12.0013 3.7549C11.9365 3.7549 11.9024 3.7549 11.8704 3.75387C11.5515 3.74361 11.2402 3.65759 10.9615 3.50224C10.9334 3.48658 10.9056 3.46956 10.8496 3.4359L10.4935 3.22213C9.90422 2.86836 9.60915 2.69121 9.29427 2.62057C9.0157 2.55807 8.72737 2.55634 8.44791 2.61471C8.13236 2.68062 7.83577 2.85276 7.24258 3.19703L7.23994 3.1982L6.75228 3.48124L6.74688 3.48454C6.15904 3.82572 5.86441 3.99672 5.6517 4.23614C5.46294 4.4486 5.32185 4.69881 5.2374 4.97018C5.14194 5.27691 5.14703 5.61896 5.15853 6.3027L5.16568 6.72736C5.16676 6.79166 5.16864 6.82362 5.16817 6.85525C5.16343 7.17499 5.08086 7.48914 4.92974 7.77096C4.9148 7.79883 4.8987 7.8267 4.86654 7.88237C4.83436 7.93809 4.81877 7.96579 4.80209 7.99268C4.63336 8.26452 4.40214 8.49186 4.12733 8.65572C4.10015 8.67193 4.0715 8.68752 4.01521 8.71871L3.65365 8.91908C3.05208 9.25245 2.75137 9.41928 2.53256 9.65669C2.33898 9.86672 2.19275 10.1158 2.10349 10.3872C2.00259 10.6939 2.00267 11.0378 2.00424 11.7255L2.00551 12.2877C2.00706 12.9708 2.00919 13.3122 2.11032 13.6168C2.19979 13.8863 2.34495 14.134 2.53744 14.3427C2.75502 14.5787 3.05274 14.7445 3.64974 15.0766L4.00808 15.276C4.06907 15.3099 4.09976 15.3266 4.12917 15.3444C4.40148 15.5083 4.63089 15.735 4.79818 16.0053C4.81625 16.0345 4.8336 16.0648 4.8683 16.1255C4.90256 16.1853 4.92009 16.2152 4.93594 16.2452C5.08261 16.5229 5.16114 16.8315 5.16649 17.1455C5.16707 17.1794 5.16658 17.2137 5.16541 17.2827L5.15853 17.6902C5.14695 18.3763 5.1419 18.7197 5.23792 19.0273C5.32287 19.2994 5.46484 19.55 5.65463 19.7627C5.86915 20.0031 6.16655 20.1745 6.76107 20.5171L7.25478 20.8015C7.84763 21.1432 8.14395 21.3138 8.45869 21.379C8.73714 21.4366 9.02464 21.4344 9.30209 21.3721C9.61567 21.3017 9.90948 21.1258 10.4964 20.7743L10.8502 20.5625C10.9062 20.5289 10.9346 20.5121 10.9626 20.4965C11.2409 20.3418 11.5512 20.2558 11.8695 20.2456C11.9015 20.2446 11.9342 20.2446 11.9994 20.2446C12.0648 20.2446 12.0974 20.2446 12.1295 20.2456C12.4484 20.2559 12.7607 20.3422 13.0394 20.4975C13.0639 20.5112 13.0885 20.526 13.1316 20.5519L13.5078 20.7777C14.0971 21.1315 14.3916 21.3081 14.7065 21.3788C14.985 21.4413 15.2736 21.4438 15.5531 21.3855C15.8685 21.3196 16.1657 21.1471 16.7586 20.803L17.2536 20.5157C17.8418 20.1743 18.1367 20.0031 18.3495 19.7636C18.5383 19.5512 18.6796 19.3011 18.764 19.0297C18.8588 18.7252 18.8531 18.3858 18.8417 17.7119L18.8343 17.2724C18.8332 17.2081 18.8331 17.1761 18.8336 17.1445C18.8383 16.8247 18.9195 16.5104 19.0706 16.2286C19.0856 16.2007 19.1018 16.1726 19.1338 16.1171C19.166 16.0615 19.1827 16.0337 19.1994 16.0068C19.3681 15.7349 19.5995 15.5074 19.8744 15.3435C19.9012 15.3275 19.9289 15.3122 19.9838 15.2818L19.9857 15.2809L20.3472 15.0805C20.9488 14.7472 21.2501 14.5801 21.4689 14.3427C21.6625 14.1327 21.8085 13.8839 21.8978 13.6126C21.9981 13.3077 21.9973 12.9658 21.9958 12.2861L21.9945 11.7119C21.9929 11.0287 21.9921 10.6874 21.891 10.3828C21.8015 10.1133 21.6555 9.86561 21.463 9.65685C21.2457 9.42111 20.9475 9.25526 20.3517 8.92378L20.3499 8.92293Z"
      stroke="#757575"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.00033 12C8.00033 14.2091 9.79119 16 12.0003 16C14.2095 16 16.0003 14.2091 16.0003 12C16.0003 9.79082 14.2095 7.99996 12.0003 7.99996C9.79119 7.99996 8.00033 9.79082 8.00033 12Z"
      stroke="#757575"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
IconSettings.displayName = 'IconSettings';

export const IconLeave = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <path
      d="M12 9L15 12L12 15M15 12H4M9 7.24859V7.2002C9 6.08009 9 5.51962 9.21799 5.0918C9.40973 4.71547 9.71547 4.40973 10.0918 4.21799C10.5196 4 11.0801 4 12.2002 4H16.8002C17.9203 4 18.4796 4 18.9074 4.21799C19.2837 4.40973 19.5905 4.71547 19.7822 5.0918C20 5.5192 20 6.07899 20 7.19691V16.8036C20 17.9215 20 18.4805 19.7822 18.9079C19.5905 19.2842 19.2837 19.5905 18.9074 19.7822C18.48 20 17.921 20 16.8031 20H12.1969C11.079 20 10.5192 20 10.0918 19.7822C9.71547 19.5905 9.40973 19.2839 9.21799 18.9076C9 18.4798 9 17.9201 9 16.8V16.75"
      stroke="#757575"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
IconLeave.displayName = 'IconLeave';

export const IconLock = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <path
      d="M9 9H7.2002C6.08009 9 5.51962 9 5.0918 9.21799C4.71547 9.40973 4.40973 9.71547 4.21799 10.0918C4 10.5196 4 11.0801 4 12.2002V17.8002C4 18.9203 4 19.4801 4.21799 19.9079C4.40973 20.2842 4.71547 20.5905 5.0918 20.7822C5.51921 21 6.07901 21 7.19694 21L16.8031 21C17.921 21 18.48 21 18.9074 20.7822C19.2837 20.5905 19.5905 20.2842 19.7822 19.9079C20 19.4805 20 18.9215 20 17.8036V12.1969C20 11.079 20 10.5192 19.7822 10.0918C19.5905 9.71547 19.2837 9.40973 18.9074 9.21799C18.4796 9 17.9203 9 16.8002 9H9ZM9 9V6.12012C9 4.39699 10.3 3 11.9037 3C12.7277 3 13.4708 3.36879 13.9993 3.96113"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
IconLock.displayName = 'IconLock';

export const IconClose = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <path
      d="M6 6L18 18M18 6L6 18"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
IconClose.displayName = 'IconClose';

export const IconDownload = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <path
      d="M12 4V14M12 14L8.5 10.5M12 14L15.5 10.5M5 18.5H19"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
IconDownload.displayName = 'IconDownload';

export const IconReply = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <path
      d="M14.5001 8.04632H11.0001V6.11932C11.0001 5.19832 10.1001 4.67332 9.47609 5.22532L4.36809 9.71532C4.25024 9.82741 4.15641 9.96229 4.0923 10.1118C4.02818 10.2612 3.99512 10.4222 3.99512 10.5848C3.99512 10.7475 4.02818 10.9084 4.0923 11.0579C4.15641 11.2074 4.25024 11.3422 4.36809 11.4543L9.47609 15.9443C10.1001 16.5003 11.0001 15.9713 11.0001 15.0513V13.1233H13.0001C13.3971 13.1263 13.7896 13.2075 14.1552 13.3622C14.5208 13.5169 14.8524 13.7421 15.131 14.025C15.4095 14.3078 15.6297 14.6428 15.7788 15.0107C15.9279 15.3786 16.0031 15.7723 16.0001 16.1693V19.0003C17.281 18.6201 18.3834 17.7939 19.1079 16.6712C19.8324 15.5485 20.131 14.2036 19.9498 12.8798C19.7685 11.556 19.1193 10.3408 18.1197 9.45424C17.12 8.56765 15.8361 8.06821 14.5001 8.04632Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
IconReply.displayName = 'IconReply';

export const IconForward = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <path
      d="M9.49649 8.04632H12.9965V6.11932C12.9965 5.19832 13.8965 4.67332 14.5205 5.22532L19.6285 9.71532C19.7463 9.82741 19.8402 9.96229 19.9043 10.1118C19.9684 10.2612 20.0015 10.4222 20.0015 10.5848C20.0015 10.7475 19.9684 10.9084 19.9043 11.0579C19.8402 11.2074 19.7463 11.3422 19.6285 11.4543L14.5205 15.9443C13.8965 16.5003 12.9965 15.9713 12.9965 15.0513V13.1233H10.9965C10.5995 13.1263 10.207 13.2075 9.84137 13.3622C9.47576 13.5169 9.14419 13.7421 8.86562 14.025C8.58704 14.3078 8.3669 14.6428 8.21778 15.0107C8.06865 15.3786 7.99346 15.7723 7.99649 16.1693V19.0003C6.71559 18.6201 5.61313 17.7939 4.88866 16.6712C4.16418 15.5485 3.86556 14.2036 4.04683 12.8798C4.2281 11.556 4.8773 10.3408 5.87692 9.45424C6.87654 8.56765 8.16053 8.06821 9.49649 8.04632Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
IconForward.displayName = 'IconForward';

export const IconPin = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <path
      d="M8.43186 15.5748L3.25586 20.7508M17.9419 6.07683L20.3839 8.51883C20.5094 8.64367 20.6063 8.79434 20.6678 8.96038C20.7293 9.12643 20.7539 9.30386 20.7399 9.48037C20.7259 9.65687 20.6736 9.82822 20.5868 9.98251C20.4999 10.1368 20.3805 10.2703 20.2369 10.3738L18.4799 10.6058C18.1269 10.6543 17.7981 10.8124 17.5399 11.0578C16.8199 11.7538 16.0869 12.4858 14.8659 13.6948C14.6559 13.9068 14.5079 14.1728 14.4389 14.4638L13.4989 18.2358C13.4197 18.4177 13.2973 18.5776 13.1424 18.7015C12.9875 18.8255 12.8047 18.9098 12.6098 18.9471C12.415 18.9844 12.214 18.9737 12.0242 18.9158C11.8345 18.8579 11.6617 18.7546 11.5209 18.6148L8.48086 15.5628L5.42886 12.5228C5.28911 12.382 5.1858 12.2092 5.12791 12.0195C5.07001 11.8297 5.05926 11.6287 5.0966 11.4339C5.13393 11.239 5.21822 11.0562 5.34216 10.9013C5.4661 10.7464 5.62595 10.624 5.80786 10.5448L9.55486 9.58083C9.84421 9.50068 10.1089 9.34942 10.3249 9.14083C11.7039 7.78583 12.2049 7.28583 12.9849 6.44283C13.2179 6.19283 13.3679 5.87783 13.4129 5.53983L13.6449 3.75683C13.7484 3.61308 13.8821 3.49361 14.0365 3.40673C14.1909 3.31985 14.3624 3.26765 14.539 3.25376C14.7157 3.23986 14.8932 3.26461 15.0593 3.32627C15.2254 3.38794 15.3761 3.48504 15.5009 3.61083L17.9419 6.07683Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
IconPin.displayName = 'IconPin';

export const IconPinnedList = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <path d="M5 7H19M5 12H21M5 17H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
));
IconPinnedList.displayName = 'IconPinnedList';

export const IconFlag = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <path
      d="M4 21V15.6871M4 15.6871C9.81818 11.1377 14.1818 20.2363 20 15.6869V4.31347C14.1818 8.86284 9.81818 -0.236103 4 4.31327V15.6871Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
IconFlag.displayName = 'IconFlag';

export const IconUpload = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <path
      d="M12 16V5M12 5L8 9M12 5L16 9M5 19H19"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
IconUpload.displayName = 'IconUpload';

export const IconCamera = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <path
      d="M4 8h2l1.5-2h9L18 8h2a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2v-8a2 2 0 012-2z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="13" r="3" stroke="currentColor" strokeWidth="1.8" />
  </svg>
));
IconCamera.displayName = 'IconCamera';

export const IconArchive = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <path
      d="M4 7h16M6 7V5a2 2 0 012-2h8a2 2 0 012 2v2M9 11h6M5 7l1 12h12l1-12"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
IconArchive.displayName = 'IconArchive';

export const IconChevronDown = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <path
      d="M6 9L12 15L18 9"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
IconChevronDown.displayName = 'IconChevronDown';

export const IconUserPlus = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <path
      d="M16 21V19C16 16.7909 14.2091 15 12 15H6C3.79086 15 2 16.7909 2 19V21M12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7C16 9.20914 14.2091 11 12 11ZM19 8V14M22 11H16"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
IconUserPlus.displayName = 'IconUserPlus';

export const IconTrash = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <path
      d="M4 7H20M9 7V5C9 4.44772 9.44772 4 10 4H14C14.5523 4 15 4.44772 15 5V7M10 11V17M14 11V17M6 7L7 19C7 19.5523 7.44772 20 8 20H16C16.5523 20 17 19.5523 17 19L18 7"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
IconTrash.displayName = 'IconTrash';

export const IconCheckCircle = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
    <path
      d="M8.5 12.2L10.9 14.6L15.7 9.8"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
IconCheckCircle.displayName = 'IconCheckCircle';
